interface Props {
    title: string;
    className?: string;
}

export function BanksPageSectionHeader({title, className = ''}: Props) {
    return (
        <h2 className={`text-lg font-semibold text-gray-800 mb-4 ${className}`.trim()}>
            {title}
        </h2>
    );
}
